import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";

const notificationService = {};

notificationService.getAll = function () {
  return axios.get(`${API_BASE_URL}/notification`);
};

notificationService.getUnreadCount = function () {
  return axios.get(`${API_BASE_URL}/notification/unread-count`);
};

notificationService.markAsRead = function (uuid) {
  return axios.patch(`${API_BASE_URL}/notification/${uuid}/read`);
};

notificationService.markAllAsRead = function () {
  return axios.patch(`${API_BASE_URL}/notification/mark-all-read`);
};

notificationService.delete = function (uuid) {
  return axios.delete(`${API_BASE_URL}/notification/${uuid}`);
};

notificationService.createEventSource = function () {
  return new EventSource(`${API_BASE_URL}/notification/stream`);
};

export default notificationService;
